import { useI18n } from '@hydra/common/customHooks';

export default function useAuthenticationRoutes () {
  const { locale } = useI18n();

  const signInRoute = `/${locale}/login`;

  const registerRoute = `/${locale}/signup`;

  const forgotPasswordRoute = `/${locale}/login/forgot`;

  const signOutRoute = '/api/user/logout';

  return {
    signInRoute,
    signOutRoute,
    registerRoute,
    forgotPasswordRoute
  };
}
